import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { AnswerTitle } from 'src/models/Answers/AnswerModel';
import * as sharedTypes from 'src/actions/shared/sharedTypes';

const fetch: sharedTypes.AppThunk =
  ({ helpCenterId = '' }) =>
  async (dispatch, getState, { gateways }) => {
    const { fetchStarted, fetchSuccess, fetchError, fetchRequestError } = answerTitlesResource.actions;

    const params = { helpCenterId, params: {} };
    gateways.answerTitles.endpoint.set(params);

    try {
      dispatch(fetchStarted({}));
      const results = await gateways.answerTitles.request(params);
      dispatch(fetchSuccess(results));
    } catch (error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    }
  };

const answerTitlesResource = createDocumentResource<AnswerTitle>({
  name: 'answerTitles',
  endpoint: 'v1/orgs/:orgId/help-center/:helpCenterId/answer-titles',
  effects: {
    fetch,
  },
  observerCreator: emptyObserverCreator,
});

export default answerTitlesResource;
